// Curated Pexels imagery used for faded page backdrops.
// All URLs use the Pexels image CDN (no auth, hot-linkable).
// To swap any of these for a custom photo later, just replace the URL.

const base = "https://images.pexels.com/photos";
const q = "?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const IMG = {
  // Hero scene: couple meeting with notary across a wooden desk (uploaded asset, locally optimized)
  homeMeeting: "/img/home-meeting.jpg",
  // OGO owl/triangle/chain brand mark
  brandLogo: "/img/ogo-logo.png",
  // Founder headshot — Dr. Gregory Byers
  headshotGreg: "/img/headshot-greg.jpg",
  // Certification seals
  certNNA: "/img/cert-nna.png",
  certBackgroundScreened: "/img/cert-background-screened.png",
  certApostille: "/img/cert-apostille.png",
  certRON: "/img/cert-ron.png",
  // Notary stamp / pen / document — establishes the trade
  notaryStamp: `${base}/28567008/pexels-photo-28567008.jpeg${q}`,
  // Couple / clients signing at a table with a professional
  signingTable: `${base}/8815849/pexels-photo-8815849.jpeg${q}`,
  // Real-estate / title-office signing handshake
  realEstateSigning: `${base}/8292784/pexels-photo-8292784.jpeg${q}`,
  // Laptop / remote video session — RON
  remoteLaptop: `${base}/574086/pexels-photo-574086.jpeg${q}`,
  // Mobile professional with bag / on the road
  mobileVisit: `${base}/8730998/pexels-photo-8730998.jpeg${q}`,
  // Wedding imagery (Unsplash — free license, locally optimized)
  weddingHero: "/img/wedding-hero.jpg",
  weddingRings: "/img/wedding-rings.jpg",
  weddingBeach: "/img/wedding-beach.jpg",
  // Smart-hero variants for /contact deep-links
  apostilleHero: "/img/apostille-hero.jpg",
  eldercareHero: "/img/eldercare-hero.jpg",
  // Apostille page — split narrative: US Capitol (state authority) + UN Geneva flags (international)
  apostilleStateHero: "/img/apostille-state-hero.jpg",
  apostilleEmbassyBackdrop: "/img/apostille-embassy-backdrop.jpg",
  // Home hero — Space Coast beach / cruise-port vibe (Cape Canaveral, Merritt Island)
  spaceCoastHero: "/img/space-coast-hero.jpg",
};

export default IMG;
